import { render } from "./Arrival.vue?vue&type=template&id=3a58bd5c"
import script from "./Arrival.vue?vue&type=script&lang=js"
export * from "./Arrival.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__